import { updateAllData } from '../../../../treeComponents/helper';
import { MILESTONE, MAIN, TEST_TYPE_MAP } from '../../Constants/Constants';
import courseManagementServices from '../../../../../service/courseManagementServices';
import { createErrorSheet } from '../../../../../helpers/helpers';
import moment from 'moment';
import { dateService } from '../../../../../../common';
import { convertDateToUTC } from '../../../../../../common/services/dateService';
import { getPhaseIndex, getWeekIndex, isTestPresentInArray } from './distributeTestsHelper';

export const getNewTestList = (dataObj: { fileData: any; testType: string; goalId: string }) => {
  const { fileData: data, goalId: courseId } = dataObj;
  const newTests: any = [];
  data.forEach((test: any) => {
    reformat(test, courseId);
    const isNewTest = !test.hasOwnProperty('testId');
    
    if (isNewTest) {
        newTests.push(test);
    }
  });
  
  return newTests;
};

const getQuestionCount = (test:any, validTests: any[]) => {
  let questionsCount;
  for(let i = 0; i < validTests.length; i++){
    if(validTests[i].testId === test.testId)
    questionsCount = validTests[i].questionsCount;
    break;
  }
  return questionsCount;
}

export const distributeTests = async (
  dataObj: { fileData: any; testType: string; goalId: string,  showMessage:(msg:string)=>void, packageId: string },
  treeData: any,
  setTreeData: Function,
  packageData: any
) => {
  const messages:string[] = [];
  const { fileData: data, testType: currentlyAdding, goalId: courseId, showMessage, packageId } = dataObj;
  
  const { phases } = treeData;
  let clonePhases = JSON.parse(JSON.stringify(phases));

  const testType = currentlyAdding === MILESTONE ? 'phase' : 'main'
  

  const results = await validate(data, courseId, testType, packageId);
  
  
  data.forEach((test: any) => {

    // if(results.validTests) {
    //   const questionsCountFromAPI = getQuestionCount(test, results.validTests)
    //   debugger;
    // }

      // if (test.startDate) {
      //   test.startDate = convertDateToUTC(new Date(test.startDate));
      //   debugger;
      // }
      // if (test.endDate) {
      //   test.endDate = convertDateToUTC(new Date(test.endDate));
      //   debugger;
      // }

      if ( currentlyAdding === MILESTONE) {
      if (isTestValid(test, results)) {
        
        addTestToPhase(test, clonePhases, messages, packageData);
      } 
    } else if (currentlyAdding === MAIN) {
      if (isTestValid(test, results)) {
        
        addTestToWeek(test, clonePhases, messages, packageData);
      } 
    }
  });

  if (messages.length) {
    sendAlert(messages, showMessage);
  }

  downloadErrorReport(data);
  updateAllData(treeData, clonePhases, setTreeData);
};

const updateTestId = (test:any, results: {validTests:any[]}) => {

}

const sendAlert = (messages: string[], showMessage: Function) => {
  if (messages.includes('Test date does not lie in any week')) {
    showMessage('Test date does not lie in any week')
  }
  else {
    if (messages.includes('Test date does not lie in any phase')) {
      showMessage('Test date does not lie in any phase')
    } else {
      if (messages.includes('Test already exists in the course')) {
        showMessage('Test already exists in the course')
      }
      else {
        if (messages.includes('Test Added')) {
          showMessage('Test Added')
        }
      }
    }
  }
}

const downloadErrorReport = (data: any[]) => {
  const errorTests:any[] = []
  data.forEach((test: any) => {
    if (test.errorMessage) {
      errorTests.push(test);
    }
  })
  if (errorTests.length) {
    createErrorSheet(errorTests, 'Error_Report.xlsx');
  }
}

export const addSuggestedTests = (testArray: any, treeData: any, setTreeData: Function, messageFunc: any, packageData: any) => {
  const { showMessage } = messageFunc;
  const { phases } = treeData;
  let clonePhases = JSON.parse(JSON.stringify(phases));
const messages:string[] = []
  testArray.forEach((test: any) => {
    if (isMilestoneTest(test)) {
      addTestToPhase(test, clonePhases, messages, packageData);
    } else if (!isMilestoneTest(test)) {
      addTestToWeek(test, clonePhases, messages, packageData);
    }
  });

  if (messages.length) {
    sendAlert(messages, showMessage);
  }

  updateAllData(treeData, clonePhases, setTreeData);
};

const reformat = (test: any, courseId: string) => {
  console.log(test)
  
  if (test.hasOwnProperty('Test Id') && test['Test Id']) {
    test.testId = test['Test Id'];
    test.contentId = test['Test Id'];
    delete test['Test Id'];
  }
  if (test.hasOwnProperty('Test Name') && test['Test Name']) {
    test.name = test['Test Name'];
    delete test['Test Name'];
  }
  if (test.hasOwnProperty('Schedule Date') && test['Schedule Date']) {
    
    test.startDate = dateService.dateYMDHHMMSSToISO(test['Schedule Date']);
    
    delete test['Schedule Date'];
  }
  if (test.hasOwnProperty('Schedule End Date') && test['Schedule End Date']) {
    
    test.endDate = dateService.dateYMDHHMMSSToISO(test['Schedule End Date']);
    

    delete test['Schedule End Date'];
  }
  if (test.hasOwnProperty('Max Attempt') && test['Max Attempt']) {
    
    test.maxAttempts = test['Max Attempt'];
    delete test['Max Attempt'];
  }
  if (test.hasOwnProperty('Type') && test['Type']) { 
    let testType = test['Type'].toLowerCase();
    if (TEST_TYPE_MAP.hasOwnProperty(testType)) {
      testType = TEST_TYPE_MAP[testType];
    }
    test.type = testType;
    delete test['Type'];
  } 
  if (test.hasOwnProperty('Revision Time') && test['Revision Time']) {
    test.blockRevisionTime = test['Revision Time'];
    test.revisionTime = test['Revision Time'];
    delete test['Revision Time'];
  } 
  if (test.hasOwnProperty('Questions Count') && test['Questions Count']) {
    test.questionsCount = test['Questions Count'];
    delete test['Questions Count'];
  } 
  if (test.hasOwnProperty('Duration') && test['Duration']) {
    test.duration = test['Duration'];
    delete test['Duration'];
  } 
  if (test.hasOwnProperty('Syllabus') && test['Syllabus']) {
    test.syllabus = test['Syllabus'];
    delete test['Syllabus'];
    
  } 

  test.courseId = courseId;

};

const isTestValid = (test: any, results: any) => {
  if (test.hasOwnProperty('testId')) {
    // check in invalidTests array
    for (const invalidTest of results.invalidTests) {
      if (invalidTest.testId === test.testId) {
        test.errorMessage = invalidTest.errorMessage;
        test.startDate = moment(test.startDate).format('YYYY-MM-DD HH:MM:SS');
        test.endDate = moment(test.endDate).format('YYYY-MM-DD HH:MM:SS');
        return false;
      }
    }
     // check in validTests array
   for (const validTest of results.validTests) {
     if (validTest.testId === test.testId) {
          test._id = validTest._id;
          test.questionsCount = validTest.questionsCount;
          
          // NEW CHANGE
          test.testId = validTest._id;
        
          test.errorMessage = validTest.errorMessage;
        return true;
      }
    }
  } else {
    test.testId = '000000000000000000000000';
    return true;
  }
};

const validate = async (data: any, courseId: string, testType: string, packageId: string) => {
  const tests: any = []
  
  // collect data for payload
  data.forEach((test: any) => {
    test.type=test.type.toLowerCase();
    if (test.hasOwnProperty('testId')) {
      tests.push(test);
    }
  });
  // create payload
  if (tests.length) {
    const params: any = {
      tests,
      courseId,
      testType,
      packageId
    };
    // hit API to validate tests
    const result = await courseManagementServices.validateTestIds(params);
    
    return result;
  }
};

const isMilestoneTest = (test: any) => {
  if (test.hasOwnProperty('endDate') || test.hasOwnProperty('scheduleEndDate')) {
    return true;
  }
  return false;
};

const addTestToPhase = (test: any, clonePhases: any, messages:string[], packageData: any) => {
  let phaseIndex = getPhaseIndex(test.endDate || test.scheduleEndDate || test.startDate, clonePhases, packageData);
  
  if (phaseIndex === -1) {
    messages.push('Test date does not lie in any phase')
  } else {
    if (!isTestPresentInArray(test.name || test.displayName, clonePhases[phaseIndex].milestoneTests)) {
      clonePhases[phaseIndex].milestoneTests.push(test);
      
      messages.push('Test Added')
    } else {
      messages.push('Test already exists in the course')
    }
  }
  if (test.startDate) {
    test.startDate = new Date(test.startDate).toString();
  }
  if (test.endDate) {
    test.endDate = new Date(test.endDate).toString();
  }
};

const addTestToWeek = (test: any, clonePhases: any, messages:string[], packageData: any) => {
  let phaseIndex = getPhaseIndex(test.startDate || test.scheduleDate, clonePhases, packageData);
  
  if (phaseIndex === -1) {
    // messages.push('Test date does not lie in any phase')
  } else {
    let weekIndex = getWeekIndex(test.startDate || test.scheduleDate, clonePhases[phaseIndex]);
    
    if (weekIndex === -1) {
        messages.push('Test Added')
        
        
      // Add Extra Tests
      if(
        (clonePhases[phaseIndex].extraTests && !isTestPresentInArray(test.name || test.displayName, clonePhases[phaseIndex].extraTests )) ||
        !clonePhases[phaseIndex].extraTests
      ) {
        
        if(clonePhases[phaseIndex].extraTests) {
          clonePhases[phaseIndex].extraTests = [...clonePhases[phaseIndex].extraTests, test]
        } else {
          clonePhases[phaseIndex].extraTests = [test]
        }
        
      }
    } else {
      if (
        !isTestPresentInArray(test.name || test.displayName, clonePhases[phaseIndex].weeks[weekIndex].content)
      ) {
        clonePhases[phaseIndex].weeks[weekIndex].content = [...clonePhases[phaseIndex].weeks[weekIndex].content, test];
        messages.push('Test Added')
      } else {
        messages.push('Test already exists in the course')
      }
    }
  }
  if (test.startDate) {
    test.startDate = new Date(test.startDate).toString();
  }
  if (test.endDate) {
    test.endDate = new Date(test.endDate).toString();
  }
};

